<template>
	<div class="component-container">
		<div class="closeBg" @click="onClick"></div>
		<div class="info" :style="{'background-image':'url('+ info_data.info_bg +')'}">
			<div class="vuebar-element" v-bar="{
				preventParentScroll: true,
				useScrollbarPseudo: true,
				}">
				<div id="vuebar-content" class="vuebar-content">
					<div id="info-content" class="info-content" v-html="activeContent"></div>
				</div>
			</div>
			<div class="links">
				<div class="link"><a @click.prevent="setActiveContent('about_content')">About</a></div>
				<div class="link"><a @click.prevent="setActiveContent('terms_of_service')">Terms of Service</a></div>
				<div class="link"><a @click.prevent="setActiveContent('privacy_policy')">Privacy Policy</a></div>
				<div :class="['link', { 'hidden': isBrainPop }]">
					<a href="https://www.mckinney.com" target="_blank" @click="trackEvent('Click', 'External Link', 'McKinney')">Made by McKinney</a>
				</div>
				<div :class="['link', { 'hidden': isBrainPop }]">
					<a :href="`mailto:${info_data.contact_us}`" @click="trackEvent('Click', 'External Link', 'Contact')">Contact Us</a>
				</div>
			</div>
			<div class="closeBtn" @click="onClick"><img :src="info_data.info_close_button"  /></div>
		</div>
	</div>
</template>

<script>
import { mapState } from 'vuex';
import tracking from '@/mixins/tracking';
import msEdgeImageSwap from '@/mixins/msEdgeImageSwap';

export default {
	name: 'Info',
	mixins: [tracking, msEdgeImageSwap],
	data() {
		return {
			selectedContent: 'about_content',
		};
	},
	computed: {
		...mapState({ // get data from wordpress info config page
			info_data: state => state.config.data.info,
			isBrainPop: state => state.config.data.game_config.brain_pop,
		}),
		activeContent() {
			if (this.selectedContent === 'privacy_policy') {
				this.trackPageview('Privacy', '/info/privacy');
				return this.info_data.privacy_policy;
			} else if (this.selectedContent === 'terms_of_service') {
				this.trackPageview('Terms', '/info/terms');
				return this.info_data.terms_of_service;
			}
			this.trackPageview('About', '/info/about');
			return this.info_data.about_content;
		},
	},
	methods: {
		onClick() {
			this.$store.commit('toggleInfoOpen', false);
		},
		setActiveContent(loc) {
			this.selectedContent = loc;
			document.getElementById("vuebar-content").scrollTop = 0;
		},
	},
	mounted() {
		this.swapEdgeImages();
	},
};
</script>
<style lang="scss">
	.info-content{
		padding: 40px 0;
		text-align: left;
		h2{
			@include breakpoint(sm){
				font-size: 1.8em;
			}
			@include breakpoint(xs){
				font-size: 1.5em;
			}
		}
		h3{
			line-height: normal;
			@include breakpoint(sm){
				font-size: 1.5em;
			}
			@include breakpoint(xs){
				font-size: 1.2em;
			}
		}
		p{
			@include breakpoint(sm){
				font-size: 1em;
			}
			@include breakpoint(xs){
				font-size: 0.875em;
			}
		}
		a {
			color: black;
			text-decoration: none;
			border-bottom: 1px solid black;
			transition: none;
			&:hover{
				border-bottom: 3px solid black;
			}
			&:hover,&:visited,&:focus,&:active{
				color: black;
				text-decoration: none;
			}
		}
		@include breakpoint(xs) {
			padding: 20px 0;
		}
	}
</style>
<style lang="scss" scoped>
	.component-container{
		width: 100%;
		height: 100%;
		position: absolute;
		display: inline-block;
		top: 0;
		left: 0;
		z-index: 10001;
		color: black;
	}
	.closeBg{
		position: absolute;
		top: 0;
		left: 0;
		height:100%;
		width: 400%;
		transform: translateX(-50%);
		background-color: rgba(0,0,0,0.3);
	}
	.info {
		width: 90%;
		height: 80%;
		max-width: 1100px;
		background-size: 100% 100%;
		-webkit-filter: blur(0px);
		background-repeat: no-repeat;
		background-position: top left;
		position: absolute;
		left: 50%;
		top: 50%;
		transform: translate(-50%, -50%);
		display: flex;
		align-items: flex-start;
		justify-content: flex-start;
		flex-direction: column;
		padding: 0px 15px 0px 5px;
		@include breakpoint(md){
			padding: 0px 10px 0px 5px;
		}
		@include breakpoint(sm) {
			padding: 0px 5px 0px 5px;
		}
	}
	.vuebar-element{
		height: calc(100% - 80px);
		width: calc(100% - 5px);
		@include breakpoint(md) {
			height: calc(100% - 60px);
			width: calc(100% - 5px);
		}
		@include breakpoint(sm) {
			height: calc(100% - 50px);
			width: calc(100% - 5px);
		}
	}
	.vuebar-content{
		margin: 5px 0% 0 9%;
		padding-right: 18% !important; // firefox weirdness
		text-align: left;
		box-sizing: border-box !important; // firefox weirdness
		@include breakpoint(md){
			margin: 2px 0% 0 4%;
			padding-right: 12% !important;
		}
	}
	.links{
		display: flex;
		align-items: center;
		justify-content: space-around;
		flex-direction: row;
		align-self:center;
		width: 80%;
		height: 60px;
		margin: 0 auto;
		position: absolute;
		bottom: 20px;
		border-top: 2px solid black;
		@include breakpoint(md){
			height: 50px;
			width: 90%;
			bottom: 10px;
		}
		@include breakpoint(sm) {
			height: 40px;
			width: 90%;
			bottom: 10px;
		}
		.link{
			display: inline-block;
			align-self: center;
			width: auto;
			text-transform: uppercase;
			text-align: center;
			@include breakpoint(md) {
				font-size: 0.85em;
			}
			@include breakpoint(sm) {
				font-size: 0.75em;
			}
			a{
				text-decoration: none;
				cursor: pointer;
				color: black;
				padding-bottom: 1px;
				border-bottom: 1px solid black;
				transition:none;
				&:hover{
					border-bottom: 3px solid black;
				}
			}
			&.hidden { display: none; }
		}
	}
	.closeBtn{
			position: absolute;
			width: 4%;
			height: auto;
			top: 4%;
			right: 4%;
			cursor: pointer;
			img{
				width: 100%;
				height: auto;
				transform: scale(0.9);
			}
			&:hover{
				img{
					transform: scale(1);
				}
			}
	}
</style>



// WEBPACK FOOTER //
// src/components/abstract/Info.vue